<template>
    <!-- --------------------------------------------------------------------------------------------------------------------------------- -->
    <!-- no mostris component si no es textbox i no té elements o si es un dropdown i el parametre showDropdownIfOnlyOneElement es false -->
    <!-- --------------------------------------------------------------------------------------------------------------------------------- -->
    <div
        v-if="
            !(
                (Object.keys(parameter.values).length === 0 &&
                    typeof parameter.value !== 'undefined' &&
                    currentFieldType !== 'textbox') ||
                (Object.keys(parameter.values).length === 1 &&
                    !showDropdownIfOnlyOneElement &&
                    currentFieldType === 'dropdown')
            )
        "
        class="d-flex"
        :style="[style_edit_param !== '' ? style_edit_param : '']"
        :class="[
            labelOverInput ? 'flex-column' : 'flex-row justify-content-between',
            parameter.justifyContent
                ? 'justify-content-' + parameter.justifyContent
                : 'justify-content-start',
            parameter.alignItems
                ? 'align-items-' + parameter.alignItems
                : 'align-items-start',
            parameter.otherclasses ? parameter.otherclasses : '',
            class_edit_param !== '' ? class_edit_param : '',
        ]"
    >
        <!-- style='max-width: 444px' -->

        <!-- --------------------------------------------------------------------------- -->
        <!-- TITLE OF THE INPUT -->
        <!-- --------------------------------------------------------------------------- -->
        <div
            v-if="currentShowTitle && currentFieldType.indexOf('textH') < 0"
            :style="style_title"
            class="text-left"
            :class="no_margin_padding_titel ? 'pt-1' : 'pt-2 pb-2 pr-2'"
        >
            <div v-if="parameter.title_size === 'h1'">
                <h1 class="font-weight-bold">{{ parameter.attribute.name ? parameter.attribute.name : parameter.attribute.id}}</h1>
            </div>
            <div v-if="parameter.title_size === 'h2'">
                <h2 class="font-weight-bold">{{ parameter.attribute.name ? parameter.attribute.name : parameter.attribute.id }}</h2>
            </div>
            <div v-if="parameter.title_size === 'h3'">
                <h3 class="font-weight-bold">{{ parameter.attribute.name ? parameter.attribute.name : parameter.attribute.id }}</h3>
            </div>
            <div v-if="parameter.title_size === 'h4'">
                <h4 class="font-weight-bold">{{ parameter.attribute.name ? parameter.attribute.name : parameter.attribute.id }}</h4>
            </div>
            <div v-if="parameter.title_size === 'h5'">
                <h5 class="font-weight-bold">{{ parameter.attribute.name ? parameter.attribute.name : parameter.attribute.id }}</h5>
            </div>
            <div v-if="parameter.title_size === 'h6'">
                <h6 class="font-weight-bold">{{ parameter.attribute.name ? parameter.attribute.name : parameter.attribute.id }}</h6>
            </div>
            <div
                v-if="parameter.title_size === 'normal'"
                class="font-weight-bold"
                style="font-size: 1rem"
            >
                {{ parameter.attribute.name  ? parameter.attribute.name : parameter.attribute.id }}
            </div>

            <tooltipAttributeValue
                :attributeValue="parameter.attribute"
            ></tooltipAttributeValue>
        </div>

        <!-- --------------------------------------------------------------------------- -->
        <!-- BODY -->
        <!-- --------------------------------------------------------------------------- -->
        <div
            v-if="currentFieldType !== ''"
            :style="{ width: parameter.field_width, backgroundColor: '' }"
            class="text-left"
        >
            <!-- BUTTON -->
            <div v-if="currentFieldType === 'button'">
                <button
                    type="button"
                    :style="{ width: parameter.width }"
                    class="btn btn-outline-secondary"
                >
                    {{ parameter.attribute.name }}
                </button>
            </div>

            <!-- LINE -->
            <div
                v-if="currentFieldType === 'line'"
                style="border-bottom: solid 3px black"
                :style="{ width: parameter.width }"
            ></div>

            <!-- TEXT -->
            <div v-if="currentFieldType === 'textH1'">
                <h1>{{ parameter.attribute.name }}</h1>
            </div>
            <div v-if="currentFieldType === 'textH2'">
                <h2>{{ parameter.attribute.name }}</h2>
            </div>
            <div v-if="currentFieldType === 'textH3'">
                <h3>{{ parameter.attribute.name }}</h3>
            </div>
            <div v-if="currentFieldType === 'textH4'">
                <h4>{{ parameter.attribute.name }}</h4>
            </div>
            <div v-if="currentFieldType === 'textH5'">
                <h5>{{ parameter.attribute.name }}</h5>
            </div>
            <div v-if="currentFieldType === 'textH6'">
                <h6>{{ parameter.attribute.name }}</h6>
            </div>
            <div
                v-if="currentFieldType === 'textNormal'"
                style="font-size: 1rem"
            >
                {{ parameter.attribute.name }}
            </div>

            <!-- TEXTBOX-->
            <div v-if="currentFieldType === 'textbox'">
                <input
                    @keyup="quantityChanged($event, 'key_' + parameter.id)"
                    @keypress="isNumber($event)"
                    @focus="onFocus($event)"
                    @change="emitChange($event)"
                    type="number"
                    :class="{
                        'is-invalid':
                            (parameter.value || parameter.value == 0) &&
                            parseInt(parameter.value) <
                                parameter.parameter_definition.rangeMin,
                    }"
                    :id="parameter.id + '_' + randomId"
                    class="form-control"
                    :name="parameter.attribute.id + '_' + randomId"
                    v-model="parameter.value"
                    :disabled="app.isProcessing"
                    :style="
                        style_inside_textbox !== '' ? style_inside_textbox : ''
                    "
                    :step="
                        parameter.parameter_definition &&
                        parameter.parameter_definition.validation === 'decimal'
                            ? '0.01'
                            : '0'
                    "
                />
                <div class="invalid-feedback">
                    <p
                        v-if="
                            (parameter.value || parameter.value == 0) &&
                            parseInt(parameter.value) <
                                parameter.parameter_definition.rangeMin
                        "
                    >
                        {{
                            $t("error_value_greater_than", {
                                value:
                                    parameter.parameter_definition.rangeMin !=
                                    null
                                        ? parameter.parameter_definition
                                              .rangeMin
                                        : 0,
                            })
                        }}
                    </p>
                </div>
            </div>

            <!-- IMG -->
            <div v-if="currentFieldType === 'image'">
                <img
                    :src="parameter.attribute.image"
                    style="max-height: 200px; width: auto; max-width: 200px"
                />
            </div>

            <!-- RADIOBUTTON-->
            <div v-if="currentFieldType === 'radiobutton'">
                <div
                    class="d-flex"
                    :class="[
                        isMobile ? 'ml-4' : '',
                        isHorizontalRadio ? 'flex-row' : 'flex-column',
                    ]"
                >
                    <div
                        v-for="(attributeValue, key, index) in parameter.values"
                        :key="attributeValue.id"
                        :data-value-id="attributeValue.id"
                    >
                        <!-- --------------------- -->
                        <!-- 1 nivell amb childs -->
                        <!-- --------------------- -->
                        <div
                            v-if="attributeValue.childs.length > 0"
                            :class="[
                                index > 0 ? 'mt-3' : '',
                                all_childs_are_disabled(attributeValue.childs)
                                    ? ''
                                    : 'mb-3',
                            ]"
                        >
                            <!-- name de cada child del nivell 1 -->
                            <p
                                v-if="
                                    !all_childs_are_disabled(
                                        attributeValue.childs
                                    )
                                "
                                class="mb-1"
                            >
                                {{ attributeValue.name ? attributeValue.name : attributeValue.id }}
                            </p>

                            <!-- ------------------ -->
                            <!-- 2 nivell amb childs-->
                            <!-- ------------------ -->
                            <!-- radio i label per cada child del nivell 1 -->
                            <div
                                v-for="child in attributeValue.childs"
                                :key="child.id"
                            >
                                <div v-if="child.childs.length === 0">
                                    <div
                                        v-if="
                                            child.status || showAllRadiobuttons
                                        "
                                        class="
                                            ml-4
                                            d-flex
                                            align-items-start
                                            justify-content-start
                                            custom-control custom-radio
                                            mb-1
                                            mt-1
                                        "
                                        :class="
                                            isTypeColumnSelector
                                                ? 'flex-row'
                                                : 'flex-column'
                                        "
                                    >
                                        <!-- :disabled="(!child.status || app.isProcessing) && !showAllRadiobuttons" -->
                                        <input
                                            type="radio"
                                            :id="
                                                child.id +
                                                '_' +
                                                parameter.attribute.id +
                                                randomId
                                            "
                                            :name="
                                                parameter.attribute.id +
                                                '_' +
                                                randomId
                                            "
                                            :value="JSON.stringify(child)"
                                            :checked="
                                                value !== null &&
                                                child.id == value.id
                                                    ? true
                                                    : false
                                            "
                                            :disabled="
                                                !child.status ||
                                                app.isProcessing
                                            "
                                            @change="emitChange"
                                            class="custom-control-input"
                                        />

                                        <label
                                            :for="
                                                child.id +
                                                '_' +
                                                parameter.attribute.id +
                                                randomId
                                            "
                                            class="
                                                custom-control-label
                                                text-left
                                            "
                                            :class="isMobile ? 'pl-0' : ''"
                                            style="background-color: white"
                                        >
                                            {{ child.name }}
                                            <!-- {{ attributeValue.name}}  / {{attributeValue.id}} / {{value.id}} / {{JSON.stringify(attributeValue)}} -->
                                        </label>
                                    </div>
                                </div>
                                <!-- -------------------- -->
                                <!-- 2 nivell sense childs-->
                                <!-- -------------------- -->
                                <div v-else>
                                    <div
                                        v-if="
                                            !all_childs_are_disabled(
                                                child.childs
                                            )
                                        "
                                        class="ml-4"
                                    >
                                        {{ child.name }}
                                    </div>
                                </div>

                                <tooltipAttributeValue
                                    :attributeValue="attributeValue"
                                ></tooltipAttributeValue>

                                <div
                                    v-if="child.childs.length > 0"
                                    class="mb-3"
                                    :class="[
                                        index > 0 ? 'mt-3' : '',
                                        !isMobile ? 'ml-5' : '',
                                    ]"
                                >
                                    <!-- <p class="mb-1">{{child.name}}</p> -->

                                    <!-- -------- -->
                                    <!-- 3 nivell -->
                                    <!-- -------- -->
                                    <div
                                        v-for="child2 in child.childs"
                                        :key="child2.id"
                                    >
                                        <div
                                            v-if="
                                                child2.status ||
                                                showAllRadiobuttons
                                            "
                                            class="
                                                d-flex
                                                flex-row
                                                align-items-start
                                                justify-content-start
                                                custom-radio
                                                mb-1
                                                mt-1
                                            "
                                            :class="!isMobile ? 'ml-4' : 'ml-5'"
                                        >
                                            <input
                                                type="radio"
                                                :id="
                                                    child2.id +
                                                    '_' +
                                                    parameter.attribute.id +
                                                    randomId
                                                "
                                                :name="parameter.attribute.id"
                                                :value="JSON.stringify(child2)"
                                                :disabled="
                                                    !child2.status ||
                                                    app.isProcessing
                                                "
                                                :checked="
                                                    value !== null &&
                                                    child2.id == value.id
                                                        ? true
                                                        : false
                                                "
                                                @change="emitChange"
                                                class="custom-control-input"
                                            />

                                            <label
                                                :for="
                                                    child2.id +
                                                    '_' +
                                                    parameter.attribute.id +
                                                    randomId
                                                "
                                                class="
                                                    custom-control-label
                                                    text-left
                                                "
                                                :class="isMobile ? 'pl-0' : ''"
                                                style="background-color: white"
                                                >{{ child2.name }}</label
                                            >

                                            <tooltipAttributeValue
                                                :attributeValue="child"
                                            ></tooltipAttributeValue>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- --------------------- -->
                        <!-- 1 nivell sense childs -->
                        <!-- --------------------- -->
                        <div v-else>
                            <div
                                v-if="
                                    attributeValue.status || showAllRadiobuttons
                                "
                                class="
                                    d-flex
                                    flex-row
                                    align-items-start
                                    justify-content-start
                                    custom-radio
                                    mb-1
                                "
                                :class="!isMobile ? 'ml-4' : ''"
                            >
                                <input
                                    type="radio"
                                    :id="
                                        attributeValue.id +
                                        '_' +
                                        parameter.attribute.id +
                                        randomId
                                    "
                                    :name="parameter.attribute.id + randomId"
                                    :value="JSON.stringify(attributeValue)"
                                    :disabled="
                                        !attributeValue.status ||
                                        app.isProcessing
                                    "
                                    :checked="
                                        value !== null &&
                                        attributeValue.id == value.id
                                            ? true
                                            : false
                                    "
                                    @change="emitChange"
                                    class="custom-control-input"
                                />

                                <label
                                    :for="
                                        attributeValue.id +
                                        '_' +
                                        parameter.attribute.id +
                                        randomId
                                    "
                                    class="custom-control-label text-left"
                                    :class="[
                                        isMobile ? 'pl-0' : '',
                                        isTypeColumnSelector && !isMobile
                                            ? 'ml-5'
                                            : '',
                                    ]"
                                    style="
                                        background-color: white;
                                        max-width: 500px;
                                    "
                                >
                                    <span v-if="!isTypeColumnSelector">
                                        {{ attributeValue.name ? attributeValue.name : attributeValue.id }}
                                    </span>
                                    <img
                                        v-if="isTypeColumnSelector && key == 0 && app.market.id !== 'deutschland'"
                                        src="https://configurator.unex.net/api/images/columna50circular.png"
                                        style="
                                            max-height: 200px;
                                            width: auto;
                                            max-width: 200px;
                                        "
                                    />
                                    <img
                                        v-if="isTypeColumnSelector && key == 1"
                                        src="https://configurator.unex.net/api/images/columna50eliptica.png"
                                        style="
                                            max-height: 200px;
                                            width: auto;
                                            max-width: 200px;
                                        "
                                    />
                                    <img
                                        v-if="isTypeColumnSelector && key == 0 && app.market.id == 'deutschland'"
                                        src="https://configurator.unex.net/api/images/columna50eliptica.png"
                                        style="
                                            max-height: 200px;
                                            width: auto;
                                            max-width: 200px;
                                        "
                                    />
                                </label>
                                <tooltipAttributeValue
                                    :attributeValue="attributeValue"
                                ></tooltipAttributeValue>
                            </div>
                        </div>
                    </div>
                    <div v-if="parameter.field_show_cleanradiobuttons"></div>
                </div>
            </div>

            <!-- DROPDOWN - COMBOBOX - DESPLEGABLE -->
            <div v-if="currentFieldType === 'dropdown'" class="d-flex flex-row">
                <select
                    @change="emitChange"
                    :style="
                        style_inside_dropdown !== ''
                            ? style_inside_dropdown
                            : ''
                    "
                    class="form-control"
                    :class="parameter.value ? '' : 'not_selected_dropdown'"
                    :disabled="app.isProcessing"
                    required
                >
                    <!-- opcio en blanc -->
                    <!-- v-if="parameter.value == ''" -->
                    <option
                        v-if="!titleInDropdown"
                        value=""
                        class="font-weight-bold"
                        :selected="value == ''"
                        hidden
                    >
                        ...
                    </option>

                    <!-- Titol dins del dropdown -->
                    <option
                        v-else
                        value=""
                        class="font-weight-bold"
                        :selected="value == ''"
                        disabled
                    >
                        {{ parameter.attribute.name }}
                    </option>
                    <!-- <option class="font-weight-bold" v-if="!parameter.valueString" disabled selected hidden>...</option> -->

                    <template v-for="attributeValue in parameter.values">
                        <!-- PARENT -->
                        <option
                            :key="attributeValue.id"
                            :value="JSON.stringify(attributeValue)"
                            :disabled="!attributeValue.status"
                            :selected="attributeValue.id === value.id"
                        >
                            <span v-if="attributeValue.status">{{
                                attributeValue.name
                            }}</span>
                            <span v-else
                                >{{ attributeValue.name }} &#x1F6C7;</span
                            >
                        </option>

                        <!-- CHILDS -->
                        <option
                            v-for="attributeValueChild in attributeValue.childs"
                            :key="attributeValueChild.id"
                            :value="JSON.stringify(attributeValueChild)"
                            :disabled="!attributeValueChild.status"
                            :selected="attributeValueChild.id === value.id"
                        >
                            <span v-if="attributeValueChild.status">{{
                                attributeValueChild.name
                            }}</span>
                            <span v-else
                                >{{ attributeValueChild.name }} &#x1F6C7;</span
                            >
                        </option>
                    </template>
                </select>
                <div v-if="html_tooltip_info_dist_max_bandeja">
                    <i
                        v-b-tooltip.hover.html
                        :title="
                            app.translate('s3_tooltip_text_dist_soportes_html')
                        "
                        id="dist_soport_info"
                        style="color: #e60000"
                        class="ml-2 fas fa-info-circle"
                    ></i>
                </div>
            </div>

            <!-- CHECKBOXES-->
            <div v-if="currentFieldType === 'checkboxes'">
                <div class="d-flex align-items-start flex-column">
                    <div
                        v-for="attributeValue in parameter.values"
                        :key="attributeValue.id"
                        class="custom-control custom-checkbox"
                    >
                        <input
                            :id="attributeValue.id"
                            :name="parameter.attribute.id"
                            :value="attributeValue"
                            :disabled="
                                !attributeValue.status || app.isProcessing
                            "
                            type="checkbox"
                            v-model="selectedValue"
                            @change="emitChangeMultiple"
                            class="custom-control-input"
                        />

                        <label
                            class="custom-control-label"
                            :for="attributeValue.id"
                            >{{ attributeValue.name }}</label
                        >

                        <tooltipAttributeValue
                            :attributeValue="attributeValue"
                        ></tooltipAttributeValue>
                    </div>

                    <!-- --------------------------- -->
                    <!-- FALTA TODO TORNAR A DESCOMENTAR, NOMES PER PROBES -->
                    <!-- --------------------------- -->
                    <!-- <div v-if="parameter.field_show_cleanradiobuttons">
                        <button
                            @click="clean()"
                            style="font-weight:lighter; border-radius: 50%;"
                            class="btn btn-outline-secondary mt-3"
                        >
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </div>-->
                    <!-- --------------------------- -->
                </div>
            </div>
        </div>

        <!-- // TODO: INFO -->
        <div v-if="false">
            <i
                v-b-tooltip.hover.html
                title="Info"
                class="ml-2 fas fa-info-circle"
            ></i>
        </div>
    </div>
</template>

<script>
// import Vue from "vue";
import { app } from "../application.js";
import parameter from "../models/parameter.js";
import tooltipAttributeValue from "./tooltipAttributeValue.vue";
import attribute from "../models/attribute";

export default {
    name: "editParameterValue",
    props: {
        parameter: new parameter(),
        mainElement: null,
        value: null,
        field_type: null,
        labelOverInput: false,
        prop_title_show: false,
        allowDecimals: false,
        no_margin_padding_titel: false,
        placeholder_titel: String,
        style_title: {
            default: "width: 220px; backgroundColor: none; fontWeight: bold"
        },
        style_edit_param: String,
        style_inside_dropdown: String,
        style_inside_textbox: String,
        class_edit_param: String,
        html_tooltip_info_dist_max_bandeja: false,
        showAllRadiobuttons: false,
        showDropdownIfOnlyOneElement: {
            type: Boolean,
            default: function () { return true }
        },
        isTypeColumnSelector: false,
        isHorizontalRadio: false,
        titleInDropdown: true,
    },
    components: { tooltipAttributeValue },
    data() {
        return {
            app: app,
            checkedNames: [],
            _selectedValue: "",
            _field_type: null,
            _show_title: false,
            nullAttribute: new attribute("", "", "", "", "", "", "", "", []),
            timeout: {},
            window: { width: 0, height: 0 },
            randomId: Math.random()
                .toString(36)
                .replace(/[^a-z]+/g, "")
                .substr(2, 10),
        };
    },
    mounted() {
        //done to allow clearance of checkboxes from clearall button in productfamilies.vue
        if (this.parameter.field_type == "checkboxes") {
            this.$parent.$on("clearCheckboxes", () => {
                this.clean();
            });
        }
    },
    beforeMount() {
        var self = this;

        //field_type used if overwritting parameter.field_type necessary
        //accessible in the template as the computed prop currentFieldType
        if (this.field_type !== null && this.field_type !== undefined) {
            this.$data._field_type = this.field_type;
        } else {
            this.$data._field_type = this.parameter.field_type;
        }

        //overwrite show_title if necessary
        if (
            this.prop_title_show !== null &&
            this.prop_title_show !== undefined
        ) {
            this.$data._show_title = this.prop_title_show;
        } else {
            this.$data._show_title = this.parameter.title_show;
        }

        // if( this.parameter.field_type=='checkboxes' && this.parameter.value == ''){
        if (this.parameter.field_type == "checkboxes") {
            //console.log("this.parameter.value: ", this.parameter.value);
            if (this.parameter.value.length == 0) {
                this.selectedValue = [];
            } else {
                this.selectedValue = this.parameter.value;
            }
        }
    },
    computed: {
        isMobile: function () {
            let a = this.window.width < 600;
            return a;
        },
        selectedValue: {
            get: function () {
                return this.$data._selectedValue;
            },
            set: function (newValue) {
                this.$data._selectedValue = newValue;
            },
        },
        currentFieldType: {
            get: function () {
                return this.$data._field_type;
            },
            set: function (newValue) {
                this.$data._field_type = newValue;
            },
        },
        currentShowTitle: {
            get: function () {
                return this.$data._show_title;
            },
            set: function (newValue) {
                this.$data._show_title = newValue;
            },
        },
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        all_childs_are_disabled: function (attributevalue_childs, nivell) {
            let tots_childs_disabled = true;

            if (attributevalue_childs.length === 1) {
                if (attributevalue_childs[0].status) {
                    tots_childs_disabled = false;
                }
            } else if (attributevalue_childs.length > 1) {
                Object.keys(attributevalue_childs).map((key) => {
                    //si te fills
                    if (
                        attributevalue_childs[key].childs &&
                        attributevalue_childs[key].childs.length
                    ) {
                        Object.keys(attributevalue_childs[key].childs).map(
                            (key2) => {
                                if (
                                    attributevalue_childs[key].childs[key2]
                                        .status
                                ) {
                                    tots_childs_disabled = false;
                                }
                            }
                        );

                        //si no te fills
                    } else {
                        Object.keys(attributevalue_childs).map((key) => {
                            if (attributevalue_childs[key].status) {
                                tots_childs_disabled = false;
                            }
                        });
                    }
                });
            }

            return tots_childs_disabled;
        },
        isNumber: function (evt) {
            // TODO: validar decimals
            // pe: en firefox deixa posar 1,5 en anglès quan no és correcte
            // console.warn(evt)
            // return;
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;

            if (
                this.allowDecimals ||
                this.parameter.parameter_definition.validation == "decimal"
            ) {
                if (
                    charCode > 31 &&
                    (charCode < 48 || charCode > 57) &&
                    charCode !== 44
                ) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            } else {
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            }
        },
        quantityChanged: async function (e, key_remove_loading) {
            var self = this;
            await self.emitDelayed(e);
        },
        update: async function () {

        },
        onFocus: async function (e) {
            var self = this;

            if (this.value == 0) {
                // Si el valor és 0, llavors modificar-lo a '' per què l'usuari
                // no hagi d'esborrar el número 0
                let inputBox = e.srcElement;
                inputBox.value = "";
            }
        },
        emitDelayed: async function (e) {
            // var self = this;
            // self.timeout = setTimeout(async function () {
            //     self.emitChange(e);
            // }, 600);
        },
        async emitChange(e) {
            var self = this;

            let oldValue = this.selectedValue;

            if (e.target.value != "") {
                this.selectedValue = JSON.parse(e.target.value);
            } else {
                this.selectedValue = "";
            }

            await this.emitAsync("beforeUpdate:value", this.parameter.attribute.id, this.selectedValue, oldValue, this.mainElement);
            await this.emitAsync("update:value", self.selectedValue);
            await this.emitAsync("afterUpdate:value", self.parameter.attribute.id, self.selectedValue, oldValue, this.mainElement);


            // Analytics
            if (this.selectedValue) {
                this.app.trackParameterSelection(
                    this.parameter.attribute.id,
                    this.selectedValue.id
                );
            }
        },
        async emitChangeMultiple(e) {
            // Convert to array of objects
            var result = [];
            // this.$emit("update:value", this.selectedValue);
            await this.$emit("beforeUpdate:value", this.parameter.id, this.selectedValue, null, this.mainElement);
            await this.$emit("update:value", this.selectedValue);
            await this.$emit("afterUpdate:value", this.parameter.id, this.selectedValue, null, this.mainElement);
        },
        async emitAsync(method, ...params) {
            let listener = this.$listeners[method] || this.$attrs[method] || this[method]
            // console.warn(listener.fns)
            if (listener) {
                //one can additionally wrap this in try/catch if needed and handle the error further
                if (typeof listener.fns[Symbol.iterator] === 'function') {
                    for (const fn of listener.fns) {
                        await fn(...params)
                    }
                } else {
                    await listener.fns(...params)
                }

            }
            return false
        },
        clean() {
            //clean selected value
            if (this.selectedValue.constructor.name == "Array") {
                this.selectedValue = [];
            } else {
                this.selectedValue = "";
            }

            this.$emit("update:value", this.selectedValue);
        },
    },
};
</script>

<style lang="scss">
.not_selected_dropdown {
    background-color: #fdfdec !important;
}

.tooltip .tooltip-inner {
    margin: 10px 10px 0 10px;
    max-width: 500px !important;
    text-align: left;
}
</style>